import { Component, Input } from '@angular/core';
import { DefaultPlaceholderDirective } from '@shared/directives/default-placeholder.directive';
import { DynamicImgUrlDirective } from '@shared/directives/dynamic-img-url.directive';
import { IconType } from '../../enums/internal-icon.enum';
import { StringUtils } from '../../utils/string-utils';

@Component({
  selector: 'app-internal-icon',
  templateUrl: './internal-icon.component.html',
  imports: [DynamicImgUrlDirective, DefaultPlaceholderDirective],
})
export class InternalIconComponent {
  @Input() name: string;
  @Input() height = 16;
  @Input() minWidth: number;
  @Input() className = '';
  @Input() iconType = IconType.SVG;
  @Input() hasFilter: boolean;
  @Input() width = 20;

  get iconSrc(): string {
    return StringUtils.getIconByType(this.name, this.iconType);
  }
}
